// export const BASE_URL = "https://acsdev.in/manaprint_backend/public/api/client";
export const BASE_URL = "https://backend.manaprint.com/public/api/client";
export const CDN_URL = "https://cdn.acsdev.in/ManaPrint";


// Production Urls::

// Client::
// https://manaprint.in/
// https://manaprint.com/

// Admin:: 
// https://admin.manaprint.com/
 
// Backend::

// 	CLIENT BASE_URL :: https://backend.manaprint.com/public/api/client

// 	ADMIN BASE URL :: https://backend.manaprint.com/public/api


// Testing Urls:: 

// Client::
// https://testing.manaprint.in

// Admin:: 
// https://admintest.manaprint.com/

// Backend::

// 	CLIENT BASE_URL :: https://backend.manaprint.in/public/api/client

// 	ADMIN BASE_URL :: https://backend.manaprint.in/public/api

// Manaprint | Personalized Gifts & Custom Printing Online
// Discover unique personalized gifts and custom printing at Manaprint ecommerce gift shop.
 